import { useContext } from 'react'
import { SalesContext } from '../context/SalesContext'

export const useSalesContext = () => {
	const context = useContext(SalesContext)
	return context
}
